<template>
  <!-- 组合商品 -->
  <div class="product-groups">
    <h3 style="text-align:left">{{group_products_title}}</h3>
    <div class="product-groups-info clearfix">
      <template v-for="(item,index) in featureImageId">
        <div class="test" v-if="checkedProduct.indexOf(item.id)!=-1" :key="index">
          <div class="J-ProductGroupsImg">
            <div class="product-groups-img">
              <a :href="'/products/'+item.url">
                <img :src="item.img" :alt="item.img" width="30%" />
              </a>
            </div>
            <!-- <div class="product-groups-link" v-if="index!=featureImageId.length-1">+</div> -->
          </div>
        </div>
      </template>
      <div class="product-groups-total">
        <div v-if="checkedProduct.length>0" class="commoditypricetype" style="padding:10px 0;">
          <span class="page_text_font">{{$t('combined.total_price')}}：</span>
          <v-selectprice
            :font-size="show_currency_selector?16:20"
            :regular-font-size="show_currency_selector?14:17"
            :disable_select="theme == 'showtime'?'true':!show_currency_selector"
            :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
            :price="this.priceTotal().priceSum"
            :regular_price_num="this.priceTotal().regularPriceSum>this.priceTotal().priceSum?this.priceTotal().regularPriceSum:''"
            fontSize="18"
          ></v-selectprice>
        </div>
        <div
          v-if="checkedProduct.length===0"
          class="product-groups-tips"
        >{{$t('combined.select_one')}}</div>
        <el-button
          class="gocart secondary_title"
          :class="checkedProduct.length===0?'soldout':'gocart'"
          type="button"
          native-type="submit"
          :loading="loading"
          :disabled="checkedProduct.length===0"
          @click="addcart"
          :style="{color:group_product_all.text_color,background:group_product_all.background_color}"
        >{{group_product_all.button_text}}</el-button>
      </div>
    </div>
    <div class="product-groups-info product-groups-list row page_text_font">
      <el-checkbox-group
        style="width:100%"
        text-color="#000000"
        fill="#000000"
        v-model="checkedProduct"
        @change="handleCheckedCitiesChange"
      >
        <!-- 主商品 -->

        <el-checkbox
          style="display:block;line-height:30px"
          :style="{opacity:checkedProduct.indexOf(product.ID)!==-1}"
          :label="product.ID"
          :key="product.ID"
          :disabled="!sub_stock[`product_${product.ID}`]"
          :checked="sub_stock[`product_${product.ID}`]"
          v-if="post_status[`product_${product.ID}`]"
        >
          <!-- {{product.post_title}} -->
          <a class="toSub" :href="'/products/'+product.post_name">{{product.post_title}}</a>
          <br v-if="group_products_position!='below'&&group_products_position!='foot'" />
          <template v-for="(items,index) in product.variant_attrs">
            <span
              :key="items.name"
              style="margin:0 3px"
              v-if="product.variants&&product.variants.length>1"
            >
              <select
                v-model="variant[`product_${product.ID}`][index].value"
                @change="changevariant(product.variants,product.ID,product)"
                style="max-width:280px"
                :name="variant[`product_${product.ID}`][index].value"
              >
                <option v-for="subitem in items.value" :key="subitem" :value="subitem">{{subitem}}</option>
              </select>
            </span>
          </template>
          <br v-if="(group_products_position!='below'&&group_products_position!='foot')&&product.variants&&product.variants.length>1" />
          <v-selectprice
            :font-size="show_currency_selector?16:20"
            :regular-font-size="show_currency_selector?14:17"
            :disable_select="theme == 'showtime'?'true':!show_currency_selector"
            :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
            style="margin:0 3px"
            :price="price[`product_${product.ID}`]"
            fontSize="18"
            :regular_price_num="regular_price[`product_${product.ID}`]>price[`product_${product.ID}`]?regular_price[`product_${product.ID}`]:''"
          ></v-selectprice>
        </el-checkbox>
        <!-- sub_products -->
        <template v-for="item in group_product">
          <el-checkbox
            style="display:block;line-height:30px"
            :style="{opacity:checkedProduct.indexOf(item.ID)!==-1}"
            :label="item.ID"
            :key="item.ID"
            :disabled="!sub_stock[`product_${item.ID}`]"
            :checked="sub_stock[`product_${item.ID}`]"
            v-if="post_status[`product_${item.ID}`]"
          >
            <a class="toSub" :href="'/products/'+item.post_name">{{item.post_title}}</a>
            <br v-if="group_products_position!='below'&&group_products_position!='foot'" />
            <template v-for="(items,index) in item.variant_attrs">
              <span
                style="margin:0 3px"
                v-if="item.variants&&item.variants.length>1"
                :key="items.ID"
              >
                <select
                  v-model="variant[`product_${item.ID}`][index].value"
                  @change="changevariant(item.variants,item.ID,item)"
                  style="max-width:280px"
                  :name="variant[`product_${item.ID}`][index].value"
                >
                  <option v-for="subitem in items.value" :key="subitem" :value="subitem">{{subitem}}</option>
                </select>
              </span>
            </template>
            <br v-if="(group_products_position!='below'&&group_products_position!='foot')&&item.variants&&item.variants.length>1" />
            <v-selectprice
              :font-size="show_currency_selector?16:20"
              :regular-font-size="show_currency_selector?14:17"
              :disable_select="theme == 'showtime'?'true':!show_currency_selector"
              :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
              style="margin:0 3px"
              :price="price[`product_${item.ID}`]"
              fontSize="18"
              :regular_price_num="regular_price[`product_${item.ID}`]>price[`product_${item.ID}`]?regular_price[`product_${item.ID}`]:''"
            ></v-selectprice>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
// @change="changevariant"
// v-model="variant[item.name][index].value"
//
// import getSymbolFromCurrency from "currency-symbol-map";

import defaultImage from "../../../../../public/images/no-image.gif";
import API from "../../../API.js";
export default {
  props: [
    "group_product",
    "group_product_all",
    // "price",
    // "regular_price",
    "stock",
    // "loading",
    "getSymbolFromCurrency",
    "smallimg",
    "pixel",
    // "variant",
    // "variant_attrs",
    "product",
    "cart_type",
    "ga",
    "group_products_title",
    "group_products_position",
    "show_currency_selector",
    "theme"
  ],
  data() {
    return {
      variant: {},
      featureImageId: [],
      variantId: {},
      price: {},
      regular_price: {},
      loading: false,
      sub_stock: {},
      post_status: {},
      checkedProduct: [],
      title: {},
      categories: {}
    };
  },
  methods: {
    dayin() {
      console.log("12312");
    },
    handleCheckedCitiesChange(value) {
      // console.log("handleCheckedCitiesChange", value);
      this.checkedProduct = value;
    },
    reload() {
      this.$forceUpdate();
    },
    priceTotal() {
      let priceSum = 0;
      let regularPriceSum = 0;
      if (this.checkedProduct.length > 0) {
        let priceAll = [];
        let regularPriceAll = [];
        this.checkedProduct.forEach(item => {
          priceAll.push(this.price[`product_${item}`]);
          regularPriceAll.push(this.regular_price[`product_${item}`]);
        });
        priceSum = priceAll.reduce(function(prev, cur, index, array) {
          return Number(prev) + Number(cur);
        });
        regularPriceSum = regularPriceAll.reduce(function(
          prev,
          cur,
          index,
          array
        ) {
          return Number(prev) + Number(cur);
        });
      }
      return { priceSum, regularPriceSum };
      // console.log("priceTotal", priceSum, regularPriceSum);
    },
    changevariant(variantAll, id, all) {
      // console.log("123123123", variantAll, id); // 商品变种信息
      // console.log("changevariant", this.variant[`product_${id}`]);
      variantAll.some(item => {
        let res = item.attrs.every(subitem => {
          return this.variant[`product_${id}`].some(lowitem => {
            return (
              lowitem.name == subitem.name && lowitem.value == subitem.value
            );
          });
        });
        if (res) {
          if (item.buy_able) {
            this.sub_stock[`product_${id}`] = true;
          } else {
            this.sub_stock[`product_${id}`] = false;
            this.checkedProduct.forEach((item, index) => {
              if (item == id) {
                this.checkedProduct.splice(index, 1);
              }
            });
          }
          this.featureImageId.forEach(imgItem => {
            if (imgItem.id == id) {
              imgItem.img =
                (item.feature_image && item.feature_image.thumbnail) ||
                (all.feature_image && all.feature_image.thumbnail) ||
                defaultImage;
            }
          });
          this.variantId[`product_${id}`] = item.ID;
          this.price[`product_${id}`] = Number(item.price);
          this.regular_price[`product_${id}`] = Number(item.regular_price);
        }
      });
      // console.log("variant", this.variant);
      // console.log("variantId", this.variantId);
      // console.log("featureImageId", this.featureImageId);
      // console.log("regular_price", this.regular_price);
      // console.log("price", this.price);
      // console.log("sub_stock", this.sub_stock);group_product_all

      this.priceTotal();
      this.reload();
    },
    async addcart() {
      let arr = [];
      this.checkedProduct.forEach(item => {
        let addproduct = { quantity: 1 };
        addproduct.product_id = item;
        if (this.variantId[`product_${item}`] !== item) {
          addproduct.variant_id = this.variantId[`product_${item}`];
        }
        arr.push(addproduct);
      });
      let obj = { product: arr };
      try {
        this.loading = true;
        let res = await this.$axios.post(API.batchCart, obj);
        if (window.fbq) {
          arr.forEach(item => {
            window.fbq("track", "AddToCart", {
              content_type: "product_group",
              content_ids: [item.product_id],
              value: this.price[`product_${item.product_id}`],
              num_items: 1,
              content_name: this.title[`product_${item.product_id}`],
              currency: res.data.currency,
              content_category: this.categories[`product_${item.product_id}`]
            });
          });
        }
        if (window.gtag) {
          window.gtag("event", "add_to_cart");
        }
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        if ((this.theme == "Brooklyn" || this.theme=='showtime') && this.cart_type == "drawer") {
          this.loading = false;
          this.$store.dispatch("change_news_cart", res.data);
          if(this.theme == "Brooklyn"){
          this.$store.dispatch("change_cart_type", true);
          }
          if(this.theme=='showtime'){
            document.body.scrollTop=document.documentElement.scrollTop=0
            this.$("#collapseExample").collapse('show');  
          }
        } else if ((this.theme == "venue"||this.theme=='showtime') && this.cart_type == "popup") {
          this.loading = false;
          this.$store.dispatch("change_news_cart", res.data);
          this.$store.dispatch("change_button_disabled", false);
          this.$("#modalCart").modal("show");
        } else {
          window.open("/cart", "_self");
          setTimeout(() => {
            this.loading = false;
          }, 5000);
        }
      } catch (error) {
        this.loading = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    }
  },
  beforeMount() {
    console.log("group_product", this.group_product);
    console.log("product", this.product);
    console.log("group_products_position", this.group_products_position);
    // variant_attrs featureImageId 数据结构初始化
    this.title[`product_${this.product.ID}`] = this.product.post_title;
    this.post_status[`product_${this.product.ID}`] =
      this.product.post_status == "publish";
    let mainCategories = [];
    if (this.product.categories && this.product.categories.length > 0) {
      this.product.categories.forEach(item => {
        mainCategories.push(item.name);
      });
    }
    this.categories[`product_${this.product.ID}`] = mainCategories;

    if (this.product.variant_attrs.length > 0) {
      const arr = [];
      this.product.variant_attrs.forEach(element => {
        arr.push({
          name: element.name,
          value: element.value[0]
        });
      });
      this.variant[`product_${this.product.ID}`] = arr;
      this.product.variants.some(list => {
        let res = list.attrs.every(attrs_item => {
          return arr.some(arr_item => {
            return (
              arr_item.name == attrs_item.name &&
              arr_item.value == attrs_item.value
            );
          });
        });
        if (res) {
          const obj = {
            id: this.product.ID,
            img:
              (list.feature_image && list.feature_image.thumbnail) ||
              (this.product.feature_image &&
                this.product.feature_image.thumbnail) ||
              defaultImage,
            url: this.product.post_name
          };
          if (list.buy_able) {
            this.sub_stock[`product_${this.product.ID}`] = true;
            // this.checkedProduct.push(this.product.ID);
          } else {
            this.sub_stock[`product_${this.product.ID}`] = false;
          }
          this.variantId[`product_${this.product.ID}`] = list.ID;
          //   this.featureImageId[`product_${this.product.ID}`] = obj;
          this.featureImageId.push(obj);
          this.price[`product_${this.product.ID}`] = Number(list.price);
          this.regular_price[`product_${this.product.ID}`] = Number(
            list.regular_price
          );
        }
      });
    } else {
      const obj = {
        id: this.product.ID,
        img:
          (this.product.feature_image &&
            this.product.feature_image.thumbnail) ||
          defaultImage,
        url: this.product.post_name
      };
      if (this.product.buy_able) {
        this.sub_stock[`product_${this.product.ID}`] = true;
        // this.checkedProduct.push(this.product.ID);
      } else {
        this.sub_stock[`product_${this.product.ID}`] = false;
      }

      this.variantId[`product_${this.product.ID}`] = this.product.ID;
      this.featureImageId.push(obj);
      this.price[`product_${this.product.ID}`] = Number(this.product.price);
      this.regular_price[`product_${this.product.ID}`] = Number(
        this.product.regular_price
      );
    }
    if (this.group_product && this.group_product.length > 0) {
      this.group_product.forEach(item => {
        this.title[`product_${item.ID}`] = item.post_title;
        this.post_status[`product_${item.ID}`] = item.post_status == "publish";
        let subCategories = [];
        if (item.categories && item.categories.length > 0) {
          item.categories.forEach(item => {
            subCategories.push(item.name);
          });
        }
        this.categories[`product_${item.ID}`] = subCategories;
        if (item.variant_attrs && item.variant_attrs.length > 0) {
          const arr = []; // 收集初始化变种商品信息
          // 变种参数信息
          item.variant_attrs.forEach(attrs => {
            arr.push({
              name: attrs.name,
              value: attrs.value[0]
            });
          });
          this.variant[`product_${item.ID}`] = arr;

          // 变种商品列表
          //   console.log('收集初始化变种商品信息',arr);
          //   variant_attrs=>>arr  variants=>>list
          item.variants.some(list => {
            let res = list.attrs.every(attrs_item => {
              return arr.some(arr_item => {
                return (
                  arr_item.name == attrs_item.name &&
                  arr_item.value == attrs_item.value
                );
              });
            });
            if (res) {
              const obj = {
                id: item.ID,
                img:
                  (list.feature_image && list.feature_image.thumbnail) ||
                  (item.feature_image && item.feature_image.thumbnail) ||
                  defaultImage,
                url: item.post_name
              };
              if (list.buy_able) {
                this.sub_stock[`product_${item.ID}`] = true;
                // this.checkedProduct.push(item.ID);
              } else {
                this.sub_stock[`product_${item.ID}`] = false;
              }
              this.price[`product_${item.ID}`] = Number(list.price);
              this.regular_price[`product_${item.ID}`] = Number(
                list.regular_price
              );
              this.variantId[`product_${item.ID}`] = list.ID;
              this.featureImageId.push(obj);
            }
          });
        } else {
          const obj = {
            id: item.ID,
            img:
              (item.feature_image && item.feature_image.thumbnail) ||
              defaultImage,
            url: item.post_name
          };
          if (item.buy_able) {
            this.sub_stock[`product_${item.ID}`] = true;
            // this.checkedProduct.push(item.ID);
          } else {
            this.sub_stock[`product_${item.ID}`] = false;
          }

          this.price[`product_${item.ID}`] = Number(item.price);
          this.regular_price[`product_${item.ID}`] = Number(item.regular_price);
          this.variantId[`product_${item.ID}`] = item.ID;
          this.featureImageId.push(obj);
        }
      });
    }

    // console.log("categories", this.categories);
    console.log("variantId", this.variantId);
    // console.log("featureImageId", this.featureImageId);
    // console.log("regular_price", this.regular_price);
    // console.log("price", this.price);
    // console.log("post_status", this.post_status);
    // console.log("sub_stock", this.sub_stock);
    // console.log("666checkedProduct", this.checkedProduct);
    // console.log("title", this.title);
  },
  mounted() {
    // console.log(typeof this.checkedProduct);
  }
};
</script>
<style lang='scss'>
// 组合商品
.product-groups {
  text-align: left;
  h3 {
    margin: 0;
    padding: 20px 0;
    word-wrap: break-word;
  }
  img {
    width: 100%;
    border-style: none;
    vertical-align: middle;
  }

  .product-groups-info {
    // .product-groups-list {
    //   margin-top: 20px;
    // }
    .toSub:hover {
      text-decoration: revert;
    }
    margin-top: 20px;
    .active {
      .el-checkbox {
        opacity: 1 !important;
      }
    }

    .el-checkbox {
      color: rgba(0, 0, 0) !important;
      white-space: normal !important;
    }

    .el-checkbox__label {
      display: inline !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #000 !important;
      border-color: #000 !important;
    }

    .el-checkbox__inner:hover {
      border-color: #000 !important;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #000 !important;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #000 !important;
    }
    .test {
      .J-ProductGroupsImg {
        .product-groups-img {
          // width: 100px;
          // min-width: 50px;
          height: 100px;
          // min-height: 50px;
          margin-bottom: 15px;
          overflow: hidden;
          display: flex;
          background: #fff;
          float: left;
          img {
            width: 100px;
          }
        }
        .product-groups-img::after {
          content: "+";
          line-height: 100px;
        }

        // .product-groups-link {
        //   float: left;
        //   height: 100px;
        //   // min-height: 50px;
        //   padding: 0 10px;
        //   font-size: 18px;
        //   display: flex;
        //   align-items: center;
        // }
      }
    }
    .test:nth-last-child(2) {
      .J-ProductGroupsImg {
        .product-groups-img::after {
          content: "";
        }
      }
    }
    .product-groups-total {
      min-width: 320px;
      width: auto;
      margin-left: 20px;
      float: left;

      .product-groups-tips {
        background: #fff1f0;
        border: 1px solid #ffa39e;
        padding: 0.35rem 0;
        text-align: center;
        margin-bottom: 10px;
        width: 340px;
        border-radius: 3px;
      }
      .gocart {
        width: 100%;
        color: #fff;
        background: #000;
        border: none !important;
      }
      .soldout {
        background: #f6f6f6 !important;
        color: #717171 !important;
      }
    }
  }
}
@media screen and (max-width: 761px) {
  .product-groups {
    .product-groups-info {
      .J-ProductGroupsImg {
        .product-groups-img {
          width: calc((100vw - 400px) / 3) !important;
          // max-width: 100px;
          height: calc((100vw - 400px) / 3) !important;
          // max-height: 100px;
        }
        .product-groups-link {
          height: calc((100vw - 400px) / 3) !important;
          max-height: 100px;
        }
      }
    }
    .product-groups-total {
      min-width: 240px !important;
    }
  }
}

@media screen and (max-width: 575px) {
  .product-groups {
    .product-groups-info {
      .J-ProductGroupsImg {
        .product-groups-img {
          width: calc((100vw - 121px) / 3) !important;
          height: calc((100vw - 121px) / 3) !important;
        }
        .product-groups-link {
          height: calc((100vw - 121px) / 3) !important;
        }
      }
    }
    .product-groups-total {
      width: 100% !important;
      min-width: 100% !important;
      margin-left: 0px !important;
    }
  }
}
</style>